import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const UndoUpLeftIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M5.24406 3.57702C5.56951 3.25171 6.09738 3.25163 6.42277 3.57702C6.74806 3.90242 6.74805 4.43032 6.42277 4.75573L4.51164 6.66687H13.3329C16.0943 6.66687 18.3329 8.90544 18.3329 11.6669C18.3327 14.4281 16.0942 16.6669 13.3329 16.6669H9.16691C8.70667 16.6669 8.33293 16.2931 8.33293 15.8329C8.33303 15.3727 8.70674 14.9999 9.16691 14.9999H13.3329C15.1737 14.9999 16.6667 13.5076 16.6669 11.6669C16.6669 9.82592 15.1739 8.33288 13.3329 8.33288H4.51164L6.42277 10.244C6.74794 10.5695 6.74812 11.0974 6.42277 11.4227C6.09742 11.748 5.56951 11.7479 5.24406 11.4227L1.91105 8.08874C1.58563 7.76332 1.58565 7.23645 1.91105 6.91101L5.24406 3.57702Z'
        fill={color}
      />
    </svg>
  )
})
